<div class="modal-header">
    <span class="modal-header-title">{{ 'CERTIFICATE.CERTIFICATE_ATTACH' | translate }}</span>
    <!-- <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss(false)">
        <span aria-hidden="true"><i class="bi bi-x-lg" style="font-size: 16px;"></i></span>
    </button> -->
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss(false)">
        <svg-icon  src="/assets/images/icons/close.svg" [stretch]="true"
        [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
    </button>
</div>
<div class="modal-body">

    <form class="form" [formGroup]="form" autocomplete="off">


        <!-- <div class="row"> -->
<!-- 
            <div class="col-3">

                <div class="certificate-img">
                    <div class="upload-file-buttons" *ngIf="!file">

                        <ff-button-upload-files  label="{{ 'UPLOAD_FILE' | translate }}" component="products" type="certificate" (uploadedFiles)="uploadedFile($event)"></ff-button-upload-files>
                        <button class="btn btn-light" type="button" (click)="onUploadFileFromStorage()">
                            <svg-icon class="" src="/assets/images/icons/upload-from-storage.svg" [stretch]="true"></svg-icon>
                        </button>
                    </div>
                    <div class="upload-file-icon-block" *ngIf="file">
                        <div class="upload-file-icon" *ngIf="checkIconExt(file.name) == 'pdf' || checkIconExt(file.name) == 'docx' || checkIconExt(file.name) == 'doc' || checkIconExt(file.name) == 'xls' || checkIconExt(file.name) == 'xlsx'">
                            <img class="product-img_size" src="/assets/images/file_icons/png/{{ checkIconExt(file.name) }}.png">
                        </div>
                        <div class="upload-file-img" *ngIf="(checkIconExt(file.name) == 'jpg' || checkIconExt(file.name) == 'png' || checkIconExt(file.name) == 'jpeg' || checkIconExt(file.name) == 'png') && fileLink != null">
                            <img class="product-img_size" src="{{ fileLink }}">
                        </div>
                    </div>
                    
                </div>

            </div> -->

            <!-- <div class="col-9"> -->

                <div class="row">

                    <div class="col-6">
                        <div *ngIf="type && type == 'attach'">
                            <label class="label">{{ 'PRODUCT.SELECTED_PRODUCTS' | translate }} <svg-icon ngbTooltip="{{ 'Обязательное для заполнения' | translate }}" placement="right" tooltipClass="clue-name" src="/assets/images/icons/info-circle.svg" [stretch]="true"></svg-icon> </label>
                            <div class="row quantity-products">
                                <div class="col-12">
                                    {{ product_ids.length }}
                                </div>
                            </div>
                        </div>
                    </div>

                    
                    <div [ngClass]="{'col-12': type && type == 'create'}" class="col-6 form-group">

                        <label class="label" for="attribute_id">{{ 'CERTIFICATE.TYPE_CERTIFICATE' | translate }} <svg-icon ngbTooltip="{{ 'Обязательное для заполнения' | translate }}" placement="right" tooltipClass="clue-name" src="/assets/images/icons/info-circle.svg" [stretch]="true"></svg-icon></label>
            
                        <ng-select 
                            class="custom"
                            notFoundText="{{ 'NO_DATA' | translate }}"
                            bindLabel="attribute_name" 
                            bindValue="attribute_id" 
                            formControlName="attribute_id"
                            [items]="certificateAttributes"
                            >
                        </ng-select>

                        <div *ngIf="errorMessages">
                            <div *ngFor="let item of errorMessages.attribute_id">
                                <div class="text-error" *ngIf="validation('attribute_id', item.type)">
                                    {{ item.message | translate: item.options }}
                                </div>
                            </div>
                        </div>
                    </div>

        
                    <div class="col-12 form-group">
        
                        <label class="label">{{ 'CERTIFICATE.CERTIFICATE' | translate }} <svg-icon ngbTooltip="{{ 'Обязательное для заполнения' | translate }}" placement="right" tooltipClass="clue-name" src="/assets/images/icons/info-circle.svg" [stretch]="true"></svg-icon> </label>

                        <div class="upload-file">

                            <div class="upload-file-btn" *ngIf="!file">

                                <div class="upload-file-placeholder">
                                    <span> Выберите файл для загрузки</span>
                                </div>
                                       
                                <div>
                                    <ff-button-upload-files  label="{{ 'UPLOAD_FILE' | translate }}" component="products" (uploadedFiles)="uploadedFile($event)"></ff-button-upload-files>
                                </div>
                                        
                                <div class="upload-file-btn-from-storage" ngbTooltip="Загрузить сертификат из хранилища" tooltipClass="clue-name" [closeDelay]="300" placement="top">
                                    <button class="btn btn-light" type="button" (click)="onUploadFileFromStorage()" >
                                        <svg-icon class="" src="/assets/images/icons/upload-from-storage.svg" [svgStyle]="{'width.px':40, 'height.px':40}"[stretch]="true"></svg-icon>
                                    </button>
                                </div>
                                
                            </div>

                            <div class="upload-file-btn-delete" *ngIf="file">

                                <div class="upload-file-name">
                                    <span>{{ file.name }}</span>
                                </div> 

                                <div>
                                    <button type="button" class="btn btn-primary btn-delete" (click)="clearFile()">{{ 'DELETE' | translate }}</button>
                                </div> 
                            </div>


                        </div>
        
                    </div>
        
                    
                    <div class="col-6 form-group">
                        <label class="label" for="date">{{ 'VALID_FORM' | translate }} <svg-icon ngbTooltip="{{ 'Обязательное для заполнения' | translate }}" tooltipClass="clue-name" placement="right" src="/assets/images/icons/info-circle.svg" [stretch]="true"></svg-icon> </label>
                        <app-date-picker-custom-view-control (changeValue)="eventFnDPVC('valid_from', $event)" [valueDateFrom]="valueDateFrom"></app-date-picker-custom-view-control>
                        <div *ngIf="errorMessages">
                            <div *ngFor="let item of errorMessages.valid_from">
                                <div class="text-error" *ngIf="validation('valid_from', item.type)">
                                    {{ item.message | translate: item.options }}
                                </div>
                            </div>
                        </div>
                    </div>
        
                    <div class="col-6 form-group">
                        <label class="label" for="date">{{ 'VALID_UNTIL' | translate }} <svg-icon ngbTooltip="{{ 'Обязательное для заполнения' | translate }}" placement="right" tooltipClass="clue-name" src="/assets/images/icons/info-circle.svg" [stretch]="true"></svg-icon> </label>
                        <app-date-picker-custom-view-control [inputValue]="validToValue" (changeValue)="eventFnDPVC('valid_to', $event)" [valueDateTo]="valueDateTo"></app-date-picker-custom-view-control>
                        <div *ngIf="errorMessages">
                            <div *ngFor="let item of errorMessages.valid_to">
                                <div class="text-error" *ngIf="validation('valid_to', item.type)">
                                    {{ item.message | translate: item.options }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
    
            <!-- </div> -->

        <!-- </div> -->

    </form>

</div>
<div class="modal-footer btn-box">
    <button type="button" class="btn btn-light btn-sm btn-custom-actions" (click)="activeModal.dismiss(false)">{{ 'CLOSE' | translate }}</button>
    <button type="button" class="btn btn-primary btn-sm btn-custom-actions" (click)="save()" [disabled]="form.invalid || (product_ids.length == 0 && type == 'attach') || !file">{{ 'SAVE'| translate }}</button>
    <!-- <button type="button" class="btn btn-primary btn-sm" (click)="save()" [disabled]="form.invalid || type == 'attach' || !file">{{ 'SAVE'| translate }}</button> -->
</div>